import { Building2, TrendingUp, Home, Layers } from 'lucide-react';
import { CardStats } from '@components/ui';
import { useMemo } from 'react';
import { getInsaatIlerlemeOzeti } from '@mocks/daireIlerleme';
import { mockBlocks, getBlocksByConstructionId } from '@mocks/bloklar';

/**
 * Yapım odaklı istatistikler — operasyonel veriler burada YOK
 * Operasyonel veriler (puantaj, günlük) OperasyonOzeti'nde gösterilir
 */
export default function DashboardStats({ insaatlar }) {
    const stats = useMemo(() => {
        let toplamBlok = 0, toplamDaire = 0, tamamlanan = 0, devamEden = 0;
        insaatlar.forEach(ins => {
            toplamBlok += getBlocksByConstructionId(ins.id).length;
            const ozet = getInsaatIlerlemeOzeti(ins.id, mockBlocks);
            if (ozet) {
                toplamDaire += ozet.toplamDaire;
                tamamlanan += ozet.tamamlanan;
                devamEden += ozet.devamEden;
            }
        });
        const ortIlerleme = insaatlar.length > 0
            ? Math.round(insaatlar.reduce((a, c) => a + (c.progress || 0), 0) / insaatlar.length)
            : 0;
        return { toplamBlok, toplamDaire, tamamlanan, devamEden, ortIlerleme };
    }, [insaatlar]);

    return (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            <CardStats title="Aktif Proje" value={insaatlar.length} icon={Building2} color="primary" size="sm" />
            <CardStats title="Ort. İlerleme" value={`%${stats.ortIlerleme}`} icon={TrendingUp} color="success" size="sm" />
            <CardStats title="Toplam Blok" value={stats.toplamBlok} icon={Layers} color="secondary" size="sm" />
            <CardStats title="Toplam Daire" value={stats.toplamDaire} icon={Home} color="info" size="sm" />
        </div>
    );
}
